import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import { BaseResponse, ResponseStatus } from '.'

export { BaseResponse, ResponseStatus }

export interface GetWebClientMessageResponse {
  maxPage: number
  messages: WebClientMessageEntity[]
  unread: number
}

export interface WebClientMessageEntity {
  webClientMessageId: string
  action: string
  title: string
  content: string
  memberId: string
  createTime: number
  readTime: number | null
  status: WebClientMessageStatus
}

export enum WebClientMessageStatus {
  Delivered = 'Delivered',
  Read = 'Read'
}

export class NotificationAPI {
  public static API_PREFIX = '/notification/v1/'

  public static getWebClientMessages(
    page: number
  ): AxiosPromise<BaseResponse<GetWebClientMessageResponse>> {
    return axios.get(`${this.API_PREFIX}/web-client-messages/?page=${page}`)
  }

  public static setMessageRead(
    ids: string[]
  ): AxiosPromise<BaseResponse<GetWebClientMessageResponse>> {
    return axios.post(`${this.API_PREFIX}/web-client-messages/read`, {
      webClientMessageIds: ids
    })
  }
}
